import AgentsOpenbook from '@components/bedrock/pages/agents/openbook';

export default AgentsOpenbook;
